import fetch from "isomorphic-fetch";
import API_URL from "helpers/apiURL";
import INTERNAL_API_URL from "helpers/internalApiUrl";

/**
 * Fetch stock parameters (brand, model, engine)
 */
export const fetchVehicleParameter = (parameter) => {
  return function (dispatch) {
    dispatch(requestVehicleParameter());

    return fetch(`${API_URL}/used/${parameter}`)
      .then((response) => response.json())
      .then((json) => dispatch(receiveVehicleParameter(parameter, json)))
      .catch((e) => {
        console.log(e);
        dispatch(receiveVehicleParameter(parameter, { data: [] }));
      });
  };
};

export const requestVehicleParameter = () => ({
  type: "REQUEST_VEHICLE_PARAMETER",
});

export const receiveVehicleParameter = (parameter, response) => ({
  type: "RECEIVE_VEHICLE_PARAMETER",
  parameter,
  data: response.data,
});

/**
 * Custom vehicle request
 */
export const requestVehicle = (data) => {
  return function (dispatch) {
    dispatch(vehicleRequested());

    return fetch(`${INTERNAL_API_URL}/used/request`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data: data }),
    })
      .then((response) => response.json())
      .then((json) => dispatch(receiveRequestConfirmation()))
      .catch((e) => {
        dispatch(vehicleRequestError());
      });
  };
};

export const vehicleRequested = () => ({ type: "VEHICLE_REQUESTED" });

export const receiveRequestConfirmation = (response) => ({
  type: "VEHICLE_REQUEST_CONFIRMED",
});

export const vehicleRequestError = () => ({ type: "VEHICLE_REQUES_FAILED" });
